import { FormGroup } from "@angular/forms";
import { Usuario } from "../despacho/Usuario";
import { AccionEliminar } from "@shared/enums/AccionEliminar";
import { UsuarioDTO } from "../notificaciones";

export class ConfiguracionBloqueoDTO {
  noBloquearPorVencido: boolean;
  noBloquearPorExcedido: boolean;
  noBloquearDiasInhabilesExcedido: boolean;
  noBloquearDiasInhabilesVencido: boolean;
  usuarioSolicitante: Usuario;

  constructor(data?: Partial<ConfiguracionBloqueoDTO>) {
    this.noBloquearPorVencido = data?.noBloquearPorVencido ?? false;
    this.noBloquearPorExcedido = data?.noBloquearPorExcedido ?? false;
    this.noBloquearDiasInhabilesExcedido = data?.noBloquearDiasInhabilesExcedido ?? false;
    this.noBloquearDiasInhabilesVencido = data?.noBloquearDiasInhabilesVencido ?? false;
  }

  static fromForm(formulario: FormGroup): ConfiguracionBloqueoDTO {
    return new ConfiguracionBloqueoDTO(formulario.value);
  }
}

export class AprobacionRechazoSolicitudBloqueo {
  usuarioAprobador: UsuarioDTO;
  solicitudesAccion: SolicitudAccionBloqueo[];
}

export class SolicitudAccionBloqueo {
  solicitudId: string;
  situacion: AccionEliminar;
}